export type DxFontId =
  | "sohne" | "barlow" | "fraunces" | "raleway"
  | "syne" | "playfair-display" | "oswald" | "hepta-slab";

export type DxCase = "uppercase" | "as-entered";

export interface DxFont {
  id: DxFontId;
  label: string;
  core?: boolean; // sohne — already globally loaded via _app.tsx
  defaultCase: DxCase;
}

export const DX_FONTS: Record<DxFontId, DxFont> = {
  sohne: { id: "sohne", label: "Söhne", core: true, defaultCase: "uppercase" },
  barlow: { id: "barlow", label: "Barlow", defaultCase: "uppercase" },
  fraunces: { id: "fraunces", label: "Fraunces", defaultCase: "as-entered" },
  raleway: { id: "raleway", label: "Raleway", defaultCase: "as-entered" },
  syne: { id: "syne", label: "Syne", defaultCase: "as-entered" },
  "playfair-display": { id: "playfair-display", label: "Playfair Display", defaultCase: "as-entered" },
  oswald: { id: "oswald", label: "Oswald", defaultCase: "uppercase" },
  "hepta-slab": { id: "hepta-slab", label: "Hepta Slab", defaultCase: "as-entered" },
};

function first(raw: string | string[] | null | undefined): string {
  return (Array.isArray(raw) ? raw[0] : raw) ?? "";
}

export function resolveDxFont(raw: string | string[] | null | undefined): DxFont {
  const id = first(raw) as DxFontId;
  return DX_FONTS[id] ?? DX_FONTS.sohne;
}

export function resolveDxCase(
  raw: string | string[] | null | undefined,
  font: DxFont,
): DxCase {
  const v = first(raw);
  if (v === "uppercase") return "uppercase";
  if (v === "as_entered") return "as-entered";
  return font.defaultCase;
}
